import Vue, { CreateElement } from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Bullet } from '@src/elements/bullet/bullet'
import { Caption } from '@src/elements/typography/typography'

import './legend.sass'

@Component
export class Legend extends Vue {

  @Prop({ required: true })
  private items: { type: string, label: string, color?: string, disabled?: boolean }[]

  @Prop({ required: false })
  private select: (item) => void

  constructor () {
    super()
  }

  render (h: CreateElement) {
    return <div class='legend'>
      {this.items.map(item => {
        return <div id={item.type} class={item.disabled ? 'legend-item disabled' : 'legend-item enabled'} ref={`${item.type}`} onClick={() => this.onSelect(item.type)}>
          {item.color ? <Bullet color={item.color} /> : null}
          <Caption class={item.disabled ? 'disabled' : ''}>{item.label}</Caption>
        </div>
      })}
    </div>
  }

  protected onSelect (type) {
    if (this.select) {
      this.select(type)
    }
  }

}
